module.exports = __webpack_public_path__ + "media/img/my-221a445c68db7c9ff4cbb5d9ba7db6be.png";